import { useMutation, useQuery } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { useHistory } from "react-router-dom";
import { createAIndividualModality, createAthleteRegister, getSchoolsByCity, searchRegistration, createTechnicalRegister, createACollectiveModality, } from "../services/api/jepis";
import useAthleteStore from "../stores/athleteStore";
import useCollectiveModalityStore from "../stores/collectiveModalityStore";
import { useErrorFeedbackStore } from "../stores/errorFeedbackStore";
import useIndividualStore from "../stores/individualStore";
import useSearchStore from "../stores/searchStore";
import useTechnicalStore from "../stores/technicalStore";
export var useGetSchoolByCity = function (city) {
    return useQuery({
        queryKey: ["get-school-by-city", city],
        queryFn: function () { return getSchoolsByCity(city); },
        enabled: Boolean(city),
    });
};
export var useCreateAthlete = function () {
    var history = useHistory();
    var applySearch = useSearchStore(function (state) { return state.applySearch; });
    var showError = useErrorFeedbackStore(function (state) { return state.showError; });
    var resetAthleteStore = useAthleteStore(function (state) { return state.reset; });
    return useMutation({
        mutationKey: ["create-athlete-register"],
        mutationFn: function (variables) {
            return createAthleteRegister(variables.payload);
        },
        onSuccess: function (data) {
            applySearch({
                tipoInscricao: "STUDENT_ATHLETE",
                codigoInscricao: data.codigo_inscricao,
                cpf: data.cpf,
                dataNascimento: data.data_nascimento,
            });
            resetAthleteStore();
            history.replace("/comprovante");
        },
        onError: function (error) {
            if (isAxiosError(error))
                if (error.response)
                    showError(error.response.data.message);
        },
    });
};
export var useCreateTechnical = function () {
    var history = useHistory();
    var applySearch = useSearchStore(function (state) { return state.applySearch; });
    var showError = useErrorFeedbackStore(function (state) { return state.showError; });
    var resetTechnicalStore = useTechnicalStore(function (state) { return state.reset; });
    return useMutation({
        mutationKey: ["create-technical-register"],
        mutationFn: function (variables) {
            return createTechnicalRegister(variables.payload);
        },
        onSuccess: function (data) {
            applySearch({
                tipoInscricao: "COACH",
                codigoInscricao: data.codigo_inscricao,
                cpf: data.cpf,
                dataNascimento: data.data_nascimento,
            });
            resetTechnicalStore();
            history.replace("/comprovante");
        },
        onError: function (error) {
            if (isAxiosError(error))
                if (error.response)
                    showError(error.response.data.message);
        },
    });
};
export var useCreateIndividualModality = function () {
    var history = useHistory();
    var applySearch = useSearchStore(function (state) { return state.applySearch; });
    var showError = useErrorFeedbackStore(function (state) { return state.showError; });
    var resetIndividualStore = useIndividualStore(function (state) { return state.reset; });
    return useMutation({
        mutationKey: ["create-individual-modality"],
        mutationFn: function (variables) {
            return createAIndividualModality(variables.payload);
        },
        onSuccess: function (data) {
            applySearch({
                tipoInscricao: "SCHOOL_INDIVIDUAL_REGISTRATION",
                codigoInep: data.instituicao.inep,
                codigoInscricao: data.codigo_inscricao,
            });
            resetIndividualStore();
            history.replace("/comprovante");
        },
        onError: function (error) {
            if (isAxiosError(error))
                if (error.response)
                    showError(error.response.data.message);
        },
    });
};
export var useSearchRegistration = function (payload) {
    return useQuery({
        queryKey: [
            "search-registration",
            payload.codigoInep,
            payload.codigoInscricao,
            payload.cpf,
            payload.dataNascimento,
        ],
        queryFn: function () { return searchRegistration(payload); },
    });
};
export var useCreateCollectiveModality = function () {
    var history = useHistory();
    var applySearch = useSearchStore(function (state) { return state.applySearch; });
    var showError = useErrorFeedbackStore(function (state) { return state.showError; });
    var resetCollectiveModalityStore = useCollectiveModalityStore(function (state) { return state.reset; });
    return useMutation({
        mutationKey: ["create-collective-modality"],
        mutationFn: function (variables) {
            return createACollectiveModality(variables.payload);
        },
        onSuccess: function (data) {
            applySearch({
                tipoInscricao: "SCHOOL_TEAM_REGISTRATION",
                codigoInep: data.instituicao_ensino.inep,
                codigoInscricao: data.codigo_inscricao,
            });
            resetCollectiveModalityStore();
            history.replace("/comprovante");
        },
        onError: function (error) {
            if (isAxiosError(error))
                if (error.response)
                    showError(error.response.data.message);
        },
    });
};
